// extracted by mini-css-extract-plugin
export default {"content":"protectedRoutes_content__XOQfB"};